<button type="button" class="{{ color() }}">
  <onyx-icon name="close-outlined" [size]="12"></onyx-icon>
</button>
